module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_row_1.89332c00.png";